var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Footer from "@/components/layout/footer";
import Header from "@/components/layout/header";
import MenuEast from "@/components/layout/menuEast";
import MenuNorth from "@/components/layout/menuNorth";
import MenuWest from "@/components/layout/menuWest";
import { useLayoutSize } from "@/hooks/layout";
import { useOutlet } from "react-router";
/**
 * <b>Composant de configuration de la page.</b>
 *
 * Ce composant structure et affiche le contenu principal de la page,
 * incluant l'en-tête, les menus latéraux et le contenu dynamique.
 *
 * @returns Le composant de configuration de la page.
 */
export default function ConfiguratorPage() {
    var outlet = useOutlet();
    var displaySize = useLayoutSize();
    var classes = {
        "display-small": displaySize.displayIsSmall,
        "display-medium": displaySize.displayIsMedium,
        "display-large": displaySize.displayIsLarge,
        "display-below-small": displaySize.displayIsBelowSmall,
        "display-above-small": displaySize.displayIsAboveSmall,
        "display-below-medium": displaySize.displayIsBelowMedium,
        "display-above-medium": displaySize.displayIsAboveMedium,
        "display-below-large": displaySize.displayIsBelowLarge,
        "display-above-large": displaySize.displayIsAboveLarge,
    };
    var classNames = Object.entries(classes)
        .filter(function (cls) { return cls[1]; })
        .map(function (cls) { return cls[0]; })
        .join(" ");
    return (_jsxs("div", __assign({ className: "layout overflow-hidden flex flex-col w-full h-full page ".concat(classNames) }, { children: [_jsx(Header, {}), _jsxs("div", __assign({ className: "flex h-full flex-row flex-auto overflow-hidden" }, { children: [_jsx(MenuWest, {}), _jsxs("div", __assign({ className: "flex flex-col bg-[var(--colors-widget)] rounded-[5px] overflow-hidden w-full" }, { children: [_jsx(MenuNorth, {}), outlet] })), _jsx(MenuEast, {})] })), _jsx(Footer, {})] })));
}
